<template>
  <div class="cloth-container" :class="[zsTjTheme]" @wheel="onMouseWheel">
    <div class="top-skin-box">
      <Skin
        :current="currentStyle"
        :currentSourceData="currentSourceData"
        :isClothSkin="true"
        :showName="currentShowStep === 1"
        :dataSource="dataSource.style"
        :hasTjContent="hasTjContent"
        :tabActive="tabActive"
        @switch="switchStyle"
      />
    </div>
    <template v-if="hasTjContent || isEdit">
      <transition-group name="fade" tag="div" mode="out-in">
        <div v-show="currentShowStep === 0" class="main-box" key="0">
          <div v-if="isEdit" class="option">
            <el-button type="primary" :loading="submitLoading" @click="handleSave(1)">发布并保存</el-button>
            <el-button type="primary" :loading="submitLoading" @click="handleSave()">保存</el-button>
          </div>
          <div class="full-left">
            <RoleInfo
              :currentStyle="currentStyle"
              :baseInfo="baseInfo"
              :currentShowData="currentShowData"
              :isEdit="isEdit"
            />
            <InfoBox :currentShowData="currentShowData" :currentShowStep="currentShowStep" />
          </div>
          <div class="full-right">
            <Battle ref="battleRef" :isEdit="isEdit" :currentShowData="currentShowData" />
          </div>
        </div>
        <div v-show="currentShowStep === 1" class="main-box" key="1">
          <div v-if="isEdit" class="option">
            <el-button type="primary" :loading="submitLoading" @click="handleSave(1)">发布并保存</el-button>
            <el-button type="primary" :loading="submitLoading" @click="handleSave()">保存</el-button>
          </div>
          <div class="full-left">
            <XpInfo :currentShowData="currentShowData" :currentShowStep="currentShowStep" />
            <TabBanner :currentShowData="currentShowData" :isEdit="isEdit" />
          </div>
          <div class="full-right live2d-right">
            <div class="live2d-box">
              <Live2d
                type="jn_live2d"
                :showLh="isShareView"
                :isShowLimit="isShowLimit"
                :dataSource="currentStyle.live2d"
                :videoSrc="currentStyle.skill.video.value"
                :attrValue="dataSource.base.character.attr1.name.value"
              />
              <div v-if="isShowLimit" class="limit-box">
                <!-- 未登录 -->
                <template v-if="!loginUid">
                  <div class="tip">该角色需要登录后才能观看哦~</div>
                  <div class="btn" @click="handleVerify">登录</div>
                </template>
                <!-- 未认证 -->
                <template v-else-if="loginUser.verify_level != 2">
                  <div class="tip">该角色需实名认证后才能观看哦~</div>
                  <div class="btn" @click="handleVerify">实名认证</div>
                </template>
                <!-- 已认证，未成年 -->
                <template v-else-if="!loginUser.adulthood">
                  <div class="tip">您的实名信息为未成年人，部分内容无法浏览</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </transition-group>
    </template>
    <StyleEmpty
      v-if="!hasTjContent && !isEdit"
      :dataSource="dataSource.style"
      :currentStyle="currentStyle"
      :stars="dataSource.base.character.stars.value"
    />

    <div v-if="hasTjContent" :class="['switching-screens', currentShowStep === 1 ? 'bottom' : 'top']">
      <div v-if="currentShowStep !== 1" class="lh-container" @click="handleToggleStep">
        <img class="lh" src="@/assets/zs_imgs/tj-fzcp-arrow-lh.png" />
        <div class="text">下滑查看XP测评</div>
      </div>
      <img v-if="zsTjTheme == 'dark'" src="@/assets/zs_imgs/cloth-arrow-down.png" alt="" @click="handleToggleStep" />
      <img
        v-if="zsTjTheme == 'light'"
        src="@/assets/zs_imgs/light-cloth-arrow-down.png"
        class="arrow-down"
        @click="handleToggleStep"
      />
    </div>

    <!-- 悬浮映射按钮 -->
    <div class="close-map-btn" id="_tj_map_btn_" ref="mapBtn" @click="openMap">
      <svg class="icon" viewBox="0 0 1024 1024" width="16" height="16">
        <path
          d="M329.142857 256a36.571429 36.571429 0 0 1 6.582857 72.557714L329.142857 329.142857h-146.285714a109.714286 109.714286 0 0 0-109.202286 99.181714L73.142857 438.857143v146.285714a109.714286 109.714286 0 0 0 99.181714 109.202286L182.857143 694.857143h292.571428a109.714286 109.714286 0 0 0 109.202286-99.181714L585.142857 585.142857V438.857143a36.571429 36.571429 0 0 1 72.557714-6.582857L658.285714 438.857143v146.285714a182.857143 182.857143 0 0 1-170.861714 182.491429L475.428571 768h-292.571428A182.857143 182.857143 0 0 1 0.365714 597.138286L0 585.142857V438.857143a182.857143 182.857143 0 0 1 170.861714-182.491429L182.857143 256h146.285714z"
          fill="#2c2c2c"
          p-id="31024"
        ></path>
        <path
          d="M694.857143 768a36.571429 36.571429 0 0 1-6.582857-72.557714L694.857143 694.857143h146.285714a109.714286 109.714286 0 0 0 109.202286-99.181714L950.857143 585.142857V438.857143a109.714286 109.714286 0 0 0-99.181714-109.202286L841.142857 329.142857h-292.571428a109.714286 109.714286 0 0 0-109.202286 99.181714L438.857143 438.857143v146.285714a36.571429 36.571429 0 0 1-72.557714 6.582857L365.714286 585.142857V438.857143a182.857143 182.857143 0 0 1 170.861714-182.491429L548.571429 256h292.571428a182.857143 182.857143 0 0 1 182.491429 170.861714L1024 438.857143v146.285714a182.857143 182.857143 0 0 1-170.861714 182.491429l-11.995429 0.365714h-146.285714z"
          fill="#2c2c2c"
          p-id="31025"
        ></path>
      </svg>
    </div>
    <!-- 映射弹框 -->
    <el-dialog
      title="服装数据修改"
      :visible.sync="visible"
      width="500px"
      custom-class="tj-map-dialog"
      center
      :append-to-body="true"
      :before-close="closeMap"
    >
      <div style="width: 100%">
        <template v-if="currentKey === 'tabSortData'">
          <draggable v-model="currentValue" :handle="'.drag-item'" :class="['drag-list']">
            <div class="drag-item" v-for="item in currentValue" :key="item">{{ item }}</div>
          </draggable>
        </template>
        <template v-else-if="currentKey.includes('bannerImg')">
          <upload-img v-model="currentValue" :maxSize="3 * 1024" />
          <span style="margin: 0 10px;">未实名美图:</span>
          <upload-img v-model="limitAgeImage" :maxSize="3 * 1024" />
        </template>
        <template v-else-if="currentKey === 'level'">
          <!-- <el-select v-model="currentValue" placeholder="请选择等级" style="width: 100%">
            <el-option v-for="item in ['T0', 'T1', 'T2', 'T3']" :key="item" :label="item" :value="item"></el-option>
          </el-select> -->
          <el-input v-model="currentValue" style="width: 100%" placeholder="请输入等级"></el-input>
        </template>
        <template v-else>
          <div>
            ①加粗：**加粗文本**；②橙字：*orange:橙色文本*；③蓝字：*blue:蓝色文本*；④加粗+橙字：***orange:橙色文本***
          </div>
          <el-input
            type="textarea"
            v-model="currentValue"
            :autosize="true"
            placeholder="请输入内容"
            style="width: 100%"
          ></el-input>
        </template>
        <div class="flex-line">
          <el-button type="primary" @click="handleOk">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import UploadImg from "@/components/Upload/UploadImg";
import Skin from "./skin.vue";
import RoleInfo from "./roleInfo.vue";
import InfoBox from "./infoBox.vue";
import Battle from "./battle.vue";
import XpInfo from "./xpInfo.vue";
import TabBanner from "./tabBanner.vue";
import Live2d from "./live2d.vue";
import StyleEmpty from "./styleEmpty.vue";
import { createPopper } from "@popperjs/core";
import { throttle, newDebounce } from "@/plugins/util";
import eventBus from "@/plugins/eventBus";
import { apiSaveContentEq, apiGetContentEqInfo } from "@/api/contentApi";

export default {
  components: {
    Skin,
    RoleInfo,
    InfoBox,
    Battle,
    XpInfo,
    TabBanner,
    draggable,
    UploadImg,
    Live2d,
    StyleEmpty
  },
  props: {
    isShowLimit: {
      type: Boolean,
      default: false
    },
    contentId: {
      type: Number,
      default: 0
    },
    currentStyle: {
      type: Object,
      default: () => {
        return {};
      }
    },
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    tjContentSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currentStepIndex: {
      type: Number,
      default: 0
    },
    isShareView: {
      type: Boolean,
      default: false
    },
    tabActive: { type: Number, default: 0 }
  },
  data() {
    return {
      tabSortData: ["宣传图", "角色档案", "生日贺图", "二创图"],
      currentMapEl: null,
      submitLoading: false,
      isEdit: false,
      visible: false,
      currentKey: "",
      currentValue: "",
      // 未实名限制图片
      limitAgeImage: "",
      // 第一屏
      currentStep: 0,
      // 保存的编辑数据
      currentSaveData: {},
      // 当前编辑的form
      currentEditForm: {}
    };
  },
  computed: {
    ...mapGetters(["loginUid", "zsTjTheme"]),
    baseInfo() {
      return this.dataSource.base || {};
    },
    currentStyleData() {
      if (this.currentStyle && this.currentStyle.key && this.tjContentSource) {
        return this.tjContentSource[this.currentStyle.key] || {};
      }
      return {};
    },
    currentShowData() {
      const res = this.isEdit ? this.currentEditForm : this.currentStyleData;
      return res;
    },
    currentSourceData() {
      const res = this.isEdit ? this.currentSaveData : this.tjContentSource;
      return res;
    },
    currentShowStep() {
      return this.isShareView ? this.currentStepIndex : this.currentStep;
    },
    hasTjContent() {
      const keys = Object.keys(this.tjContentSource);
      return keys.length > 0;
    }
  },
  watch: {
    currentStyle(newVal) {
      if (newVal && newVal.key) {
        this.isEdit = false;
      }
    },
    contentId(val) {
      if (this.loginUser.is_super && !this.isShareView) {
        this.getClothInfo();
      }
    }
  },
  mounted() {
    eventBus.$on("editCloth", this.handleChangeEdit);
    window.addEventListener("mousemove", this.hideMap, true);
    if (this.loginUser.is_super && !this.isShareView) {
      this.getClothInfo();
    }
  },
  beforeDestroy() {
    eventBus.$off("editCloth", this.handleChangeEdit);
    window.removeEventListener("mousemove", this.hideMap, true);
  },
  activated() {
    eventBus.$on("editCloth", this.handleChangeEdit);
    window.addEventListener("mousemove", this.hideMap, true);
  },
  deactivated() {
    eventBus.$off("editCloth", this.handleChangeEdit);
    window.removeEventListener("mousemove", this.hideMap, true);
  },
  methods: {
    handleVerify() {
      this.$emit("handleVerify");
    },
    handleToggleStep() {
      this.currentStep = this.currentStep === 0 ? 1 : 0;
      this.$emit("handleStepChange", this.currentStep);
    },
    addWheelListener() {
      this.removeWheelListener();
      document.addEventListener("wheel", this.onMouseWheel, { passive: true });
    },
    onMouseWheel: newDebounce(function(event) {
      if (!this.hasTjContent && !this.isEdit) return;

      if (event.deltaY > 0) {
        if (this.currentStep >= 1) return;
        this.currentStep += 1;
      }
      if (event.deltaY < 0) {
        if (this.currentStep <= 0) return;
        this.currentStep -= 1;
      }
      this.$emit("handleStepChange", this.currentStep);
    }, 100),

    removeWheelListener() {
      document.removeEventListener("wheel", this.onMouseWheel);
    },
    getClothInfo() {
      if (!this.contentId) return;
      apiGetContentEqInfo({ content_id: this.contentId }).then(res => {
        if (res.code === 0 && res.data) {
          const { content } = res.data;
          this.currentSaveData = JSON.parse(content || "{}");
        }
      });
    },
    switchStyle(key, index) {
      this.$emit("switchStyle", key, index);
    },
    handleChangeEdit() {
      this.isEdit = !this.isEdit;
      if (this.isEdit) {
        const key = this.currentStyle.key;
        const obj = this.currentSaveData[key] || {};
        this.currentEditForm = Object.assign({}, obj);
        setTimeout(() => {
          this.initMapElEvent();
        });
      }
    },
    initMapElEvent() {
      const needMapEl = document.querySelectorAll("[data-map-key]");
      needMapEl.forEach(el => {
        el.addEventListener("mouseenter", this.showMap);
      });
    },
    showMap(e) {
      if (!this.isEdit) return;
      const mapKey = e.target.dataset.mapKey;
      const mapBtn = document.getElementById("_tj_map_btn_");
      const currentMapEl = e.target;
      this.currentMapEl = currentMapEl;
      mapBtn.setAttribute("data-show", "");
      mapBtn.setAttribute("data-el-map-key", mapKey);
      createPopper(currentMapEl, mapBtn, {
        placement: "top-start",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1]
            }
          }
        ]
      });
    },
    hideMap: throttle(function(e) {
      if (this.visible) return;
      if (!this.$refs) return;
      const mapBtn = document.getElementById("_tj_map_btn_");
      const currentEl = e.target;
      if (!(mapBtn.contains(currentEl) || (this.currentMapEl && this.currentMapEl.contains(currentEl)))) {
        mapBtn.removeAttribute("data-show");
        mapBtn.removeAttribute("data-el-map-key");
      }
    }, 500),
    openMap(e) {
      const mapBtn = document.getElementById("_tj_map_btn_");
      const mapKey = mapBtn.dataset.elMapKey;
      this.currentKey = mapKey;
      if (mapKey === "tabSortData") {
        // 排序tab
        this.currentValue = this.currentShowData.tabSortData || this.tabSortData;
      } else {
        if (mapKey.includes("bannerImg")) {
          // 美图
          this.limitAgeImage = this.currentShowData[`${mapKey}_limit`] || "";
        }
        this.currentValue = this.currentShowData[mapKey] || "";
      }

      this.visible = true;
      // 隐藏映射按钮
      mapBtn.removeAttribute("data-show");
      mapBtn.removeAttribute("data-el-map-key");
      mapBtn.removeAttribute("data-el-map-type");
    },
    closeMap() {
      this.visible = false;
      this.currentKey = "";
      this.currentValue = "";
      this.limitAgeImage = "";
    },
    handleOk() {
      this.$set(this.currentEditForm, this.currentKey, this.currentValue);
      if (this.currentKey.includes("bannerImg")) {
        this.$set(this.currentEditForm, `${this.currentKey}_limit`, this.limitAgeImage);
      }

      this.visible = false;
    },
    handleSave(sub) {
      const battleRef = this.$refs.battleRef;
      const battleData = battleRef.roundInfos;

      // 点击保存
      const params = {
        content_id: this.contentId,
        is_sub: !!sub
      };
      const content = {};
      const currentStyleKey = this.currentStyle.key;
      if (this.currentSourceData) {
        Object.assign(content, this.currentSourceData);
      }
      content[currentStyleKey] = this.currentEditForm;
      content[currentStyleKey].battleData = battleData;
      params.content = JSON.stringify(content);
      this.submitLoading = true;
      apiSaveContentEq(params)
        .then(res => {
          if (res.code === 0) {
            this.$message.success("保存成功");
            window.location.reload();
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.tj-map-dialog {
  .flex-line {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
  .drag-list {
    display: flex;
    align-items: center;
    .drag-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 32px;
      padding: 0 10px;
      background-color: #f5f5f5;
      border: 1px solid #d8d8d8;
      cursor: move;
      &:hover {
        background-color: #e0e0e0;
      }
    }
  }
}
.close-map-btn {
  display: none;
  z-index: 2000;
  width: 24px;
  height: 24px;
  background: transparent;
  cursor: pointer;
  text-align: center;
  line-height: 24px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px,
    rgba(17, 17, 26, 0.1) 0px 16px 56px;
  align-items: center;
  justify-content: center;
  &[data-show] {
    display: flex;
  }
}
.cloth-container {
  position: relative;
  width: 100%;
  height: 100%;
  padding-left: 52px;
  box-sizing: border-box;
  @keyframes beat {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-20px);
    }
  }
  @keyframes beatbottom {
    0%,
    100% {
      transform: translateY(0) rotate(180deg);
    }
    50% {
      transform: translateY(-20px) rotate(180deg);
    }
  }
  .switching-screens {
    position: absolute;
    z-index: 10;
    left: 0;
    width: 100%;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    row-gap: 10px;
    &.top {
      bottom: 50px;
      animation: beat 1.5s linear infinite;
      .arrow-down {
        padding: 0px;
      }
    }
    &.bottom {
      top: 30px;
      animation: beatbottom 1.5s linear infinite;
      .arrow-down {
        padding: 20px;
      }
    }
    .lh-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      .lh {
        width: 80px;
        height: 60px;
        object-fit: cover;
        object-position: center top;
      }
      .text {
        white-space: nowrap;
        border: 1px solid rgba(255, 255, 255, 0.32);
        border-radius: 30px;
        box-sizing: content-box;
        padding: 2px 10px;
        background-color: rgba(0, 0, 0, 0.1);
        color: #fff;
        font-size: 12px;
      }
    }
    .arrow {
      width: 41px;
      height: 22px;
      cursor: pointer;
    }
    .arrow-down {
      width: 33px;
      box-sizing: content-box;
    }
  }

  .top-skin-box {
    z-index: 3;
    position: absolute;
    top: 40px;
    left: 52px;
    width: 667px;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(216, 216, 216, 0.14);
  }
  .main-box {
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    .option {
      z-index: 4;
      position: absolute;
      top: 114px;
      right: 276px;
    }
    .full-left {
      z-index: 2;
      display: flex;
      flex-direction: column;
      flex: 0 0 auto;
      max-height: 100%;
      width: 667px;
      padding-top: 184px;
      margin-right: 96px;
      overflow: hidden;
    }
    .full-right {
      position: relative;
      flex: 0 0 auto;
      width: 536px;
      padding-top: 158px;
    }
    .live2d-right {
      position: relative;
      width: 2560px;
      height: 100%;
      padding-top: 0;
      max-height: 1080px;
      min-height: 896px;
      // background: #5989dc;
      margin-left: -980px;
      .live2d-box {
        width: 100%;
        height: 1600px;
      }
      .limit-box {
        z-index: 1001;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 336px;
        height: 28px;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        justify-content: center;

        &::before {
          content: "";
          display: block;
          position: absolute;
          z-index: 1000;
          left: 0;
          right: 0;
          width: 100%;
          height: 100%;
          background: rgba(64, 118, 174, 0.6);
          border-radius: 0px 0px 0px 0px;
          filter: blur(16px);
        }

        .tip {
          position: relative;
          z-index: 1001;
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
          line-height: 16px;
        }
        .btn {
          position: absolute;
          top: 38px;
          left: 50%;
          transform: translateX(-50%);
          font-weight: 500;
          font-size: 17px;
          color: #3eaffe;
          line-height: 16px;
          text-decoration: underline;
          text-underline-offset: 2px;
          cursor: pointer;
        }
      }
    }
  }
}
.cloth-container.light {
  .switching-screens .lh-container .text {
    background-color: rgba(38, 136, 176, 0.16);
    border: 1px solid rgba(0, 0, 0, 0.28);
    color: #000000;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
